<app-exit-table-header (filterValues)="onFiltersApply($event)"></app-exit-table-header>
<app-table-items>
  <app-table-item *ngFor="let crate of crates; let odd = odd" [isOdd]="odd" class="item">

    <app-table-column name="receivedAt" size="small" (click)="itemClicked(crate)">
      <span content>{{formatDate(crate.receivedAt)}}</span>
    </app-table-column>

    <app-table-column name="lastMovedAt" size="small" (click)="itemClicked(crate)">
      <span content>{{formatDate(crate.lastMovedAt)}}</span>
    </app-table-column>

    <app-table-column name="section" size="small" (click)="itemClicked(crate)">
      <span content>{{crate.section || '---'}}</span>
    </app-table-column>

    <app-table-column name="alias" size="smallest" (click)="itemClicked(crate)">
      <span content>{{crate.alias || '---'}}</span>
    </app-table-column>
<!-- 
    <app-table-column name="levelName" size="smaller" (click)="itemClicked(crate)">
      <span content>{{crate.levelName || '---'}}</span>
    </app-table-column>

    <app-table-column name="height" size="smallest" (click)="itemClicked(crate)">
      <span content>{{ crate.z >= 0 ? centimetersToMeters(crate.z) + ' metros' : 'Conflitante' }}</span>
    </app-table-column>
   -->

    <app-table-column name="type" size="smaller" (click)="itemClicked(crate)">
      <span content>{{getCrateType(crate.type)}}</span>
    </app-table-column>

    <app-table-column name="product-code" size="small" (click)="itemClicked(crate)">
      <span content>
        <span *ngFor="let product of crate.skuGroups">{{ product.sku || '---' }}</span>
        <span *ngIf="!crate.skuGroups || crate.skuGroups.length === 0">---</span>
      </span>
    </app-table-column>

    <app-table-column name="description" size="medium" (click)="itemClicked(crate)">
      <span content>
        <span *ngFor="let product of crate.skuGroups">{{ product.name || '---' }}</span>
        <span *ngIf="!crate.skuGroups || crate.skuGroups.length === 0">---</span>
      </span>
    </app-table-column>

    <app-table-column name="family" size="medium" (click)="itemClicked(crate)">
      <span content>
        <span *ngFor="let product of crate.skuGroups">{{ product.description || '---' }}</span>
        <span *ngIf="!crate.skuGroups || crate.skuGroups.length === 0">---</span>
      </span>
    </app-table-column>

    <app-table-column name="quantity" size="qtd" alignRight="true" (click)="itemClicked(crate)">
      <span content>
        <span *ngFor="let product of crate.skuGroups">
          <ng-container *ngIf="product.quantity != null">
            {{ product.quantity * product.packSize | number : '1.0-0' : 'pt-BR' }}
          </ng-container>
          <span *ngIf="product.quantity == null">---</span>
        </span>
        <span *ngIf="!crate.skuGroups || crate.skuGroups.length === 0">---</span>
      </span>
    </app-table-column>

    <app-table-column name="messages" size="smallest" alignRight="true" (click)="itemClicked(crate, 'messages')">
      <span content>
        <i *ngIf="!crate.commentsQty" class="uil uil-comment"></i>
        <i *ngIf="crate.commentsQty" class="uil uil-comment-lines"></i>
        {{ crate.commentsQty | number:'1.0-0':'pt-BR' }}
      </span>
    </app-table-column>

  </app-table-item>
</app-table-items>